/**
 * Anchor target id for the full disclaimer card. The card is rendered near the
 * end of the article (below the "About the author" block — see CMS-1783); the
 * short disclaimer's link scrolls to it.
 */
export const DISCLAIMER_ANCHOR_ID = 'article-disclaimer';
